// extracted by mini-css-extract-plugin
export default {"timer":"styles_timer__EUj5z","icon":"styles_icon__CuUZA","text":"styles_text__5drGL"};